// extracted by mini-css-extract-plugin
module.exports = {"counter":"a10a3f92e9--counter--3Rmv1","icon":"a10a3f92e9--icon--2_U2n","text":"a10a3f92e9--text--1yyqj"};